export default "__VITE_ASSET__0653e9bd__"